import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  IBulkPrintRequestSearchBody,
  IBulkPrintRequestSearchResult,
  IBulkPrintRequestSearchResultRecord,
} from '@assess/shared/data-mart-search';

import { SearchService } from './search.service';

@Injectable({ providedIn: 'root' })
export class BulkPrintRequestSearchService {
  private readonly resourceType = 'bulkprintrequest';

  constructor(private readonly searchService: SearchService) {}

  search(body: Partial<IBulkPrintRequestSearchBody>): Observable<IBulkPrintRequestSearchResult> {
    return this.searchService.search<IBulkPrintRequestSearchResultRecord>(this.resourceType, body);
  }
}
